/**
 * GDS Microfrontend Wrapper Web Component
 * Simple passthrough wrapper that renders a dynamic inner web component
 */
class GdsMicrofrontend extends HTMLElement {
	connectedCallback() {
		this.render()
	}

	private render() {
		const kebabize = (str:string) => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? "-" : "") + $.toLowerCase())

		const componentName = this.getAttribute('component')
		const moduleName = this.getAttribute('module')
		const env = this.getAttribute('environment')
		const consumer = this.getAttribute('consumer')
		const site = this.getAttribute('site')
		const lang = this.getAttribute('language')

		if (!componentName) {
			this.innerHTML = '<div>Please specify a component name using the "component" attribute</div>'
			return
		}

		if (!consumer) {
			this.innerHTML = '<div>Please specify consumer name using the "consumer" attribute</div>'
			return
		}

		if (!site) {
			this.innerHTML = '<div>Please specify site using the "site" attribute</div>'
			return
		}

		let baseUrl = ''
		switch (env) {
			case 'dit':
				baseUrl = 'https://gui.dit.tdsynnex.com'
				break
			case 'sit':
				baseUrl = 'https://gui.sit.tdsynnex.com'
				break
			case 'uat':
				baseUrl = 'https://gui.uat.tdsynnex.com'
				break
			default:
				baseUrl = 'https://gui.tdsynnex.com'
				break
		}

		const baseUrlOverride = this.getAttribute('base-url');
		if (baseUrlOverride) {
			baseUrl = baseUrlOverride
		}

		fetch(`${baseUrl}/ui-gds/v1/wrapper/${componentName}`, {
			method: 'GET',
			headers: {
				Site: site,
				Consumer: consumer,
				'Accept-Language': lang!
			},
			credentials: 'omit',
		})
			.then((r) => r.json())
			.then((v) => {
				const scrpt = document.createElement('script')

				if (v.isEnabled) {
					scrpt.type = 'module'
					scrpt.src = `${v.cdnBaseUrl}/${componentName}/${v.fileVersion}/${
						moduleName || componentName
					}.js`

					const lnk = document.createElement('link')
					lnk.rel = 'stylesheet'
					lnk.href = `${v.cdnBaseUrl}/${componentName}/${v.fileVersion}/${componentName}.css`

					// add script of the microfrontend
					if(!document.querySelector(`script[src="${scrpt.src}"]`))
						document.head.appendChild(scrpt)

					// add css of the microfrontend (it might be 404 - that is fine)
					if(!document.querySelector(`link[href="${lnk.href}"]`))
						document.head.appendChild(lnk)

					const children = Array.from(this.childNodes)
					const innerComponent = document.createElement(moduleName || componentName) // componentName should match script name!

					// set baseUrl from api response
					// if attribute is set it will override api response (we want this behaviour)
					innerComponent.setAttribute('base-url', v.baseUrl)

					Array.from(this.attributes).forEach((attr) => {
						if (attr.name !== 'component' && attr.name !== 'environment' && attr.name !== 'module') {
							innerComponent.setAttribute(attr.name, attr.value)
						}
					})

					// Spread v entries as attributes on the inner component
					// overrides every attribute except baseUrl
					Object.entries(v).forEach(([key, value]) => {
						if (typeof value !== 'object' && value !== undefined && key != 'baseUrl') {
							innerComponent.setAttribute(kebabize(key), String(value))
						}
					})

					children.forEach((child) => {
						innerComponent.appendChild(child)
					})

					this.parentNode?.replaceChild(innerComponent, this)
				}
			})
	}
}

// Register the custom element globally when script loads
customElements.get('gds-microfrontend') || customElements.define('gds-microfrontend', GdsMicrofrontend)
